import React from "react";
import styled from "styled-components";
import { i18n } from "../../services";
import { device } from "../../helpers/style";

const Container = styled.div``;
const Titles = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    color: #999;
    background-color: #ebebeb;
`;
const Title = styled.div<{
    isActive: boolean;
}>`
    border-bottom: 2px solid #000;
    color: ${(p) => (p.isActive ? "#fff" : "#000")};
    background-color: ${(p) => (p.isActive ? "#000" : "#fff")};
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 10px 0;
    font-size: 18px;
    font-weight: 500;
    font-family: Cairo, QuranFont, urdu, sans-serif;

    @media ${device.phone} {
        font-size: 16px;
    } ;
`;

interface TabsProps {
    titles: string[];
    activeTab: string;
    onSelect: (name: string) => void;
}
export class Tabs extends React.Component<TabsProps> {
    titles() {
        return (
            <Titles>
                {this.props.titles.map((name) => (
                    <Title
                        key={`tab-${name}`}
                        isActive={name === this.props.activeTab}
                        onClick={() => this.props.onSelect(name)}
                    >
                        {i18n.get(`tab.${name}`)}
                    </Title>
                ))}
            </Titles>
        );
    }

    render() {
        return (
            <Container>
                {this.titles()}
                {this.props.children}
            </Container>
        );
    }
}
